// extracted by mini-css-extract-plugin
export default {"fr-view":"Email_fr-view__rRYjl","container":"Email_container__rsQ6j","icon":"Email_icon__vNKrQ","grow":"Email_grow__vWHtP","title":"Email_title__3hmJx","field":"Email_field__ARg8y"};